<!-- <ng-container  *ngIf="on_board_mode">
  <span class="text-danger">Disable On boarding mode to change roles</span>
  <br>
</ng-container> -->
<div *ngIf="!expired">
  <strong>Change View</strong>
  <ul>
    <li class="role-item" *ngIf="isprimaryaccount">
      <a href="javascript:void(0);" style="text-decoration: none;" (click)="toggleOnBoardStatus()">
        <div class="flex align-items-center" (click)="setRole()">
          <img src="../../../../assets/img/onboarding-side-bar.svg" alt="" class="role-icon">
          <p class="role-name">{{enableOnBoard}}</p>
          <div class="ml-auto">
            <p-inputSwitch [(ngModel)]="toggleFlag" />
          </div>
        </div>
      </a>
    </li>
    <li *ngFor="let role of loggedInUser.role" class="role-item" [ngClass]="{'op-5': toggleFlag, 'active': role.role_name == currentRole && !toggleFlag}">
      <div class="flex align-items-center" (click)="setRole(role)">
        <img src="../../../../assets/img/role-icon.svg" alt="" class="role-icon">
        <p class="role-name">{{role.role_name}}</p>
        <div class="ml-auto" *ngIf="role.role_name == currentRole && !toggleFlag">
          <img src="../../../../assets/img/role-checked.svg" alt="" class="icon-checked">
        </div>
      </div>
    </li>
  </ul>

</div>
<p-divider></p-divider>
<div class="text-center"><a href="javascript:void(0);" (click)="logout()" class="text-danger">Logout</a></div>
